<section class="menu-shell">
  <header class="menu-hero">
    <div>
      <h2 class="menu-title">{{ isEditMode ? 'Editar Menu' : 'Novo Menu' }}</h2>
      <p class="menu-subtitle">{{ isEditMode ? 'Atualize as informações do menu selecionado.' : 'Preencha os dados para cadastrar um novo menu.' }}</p>
    </div>
    <span class="menu-chip">{{ isEditMode ? 'Edição' : 'Cadastro' }}</span>
  </header>

  <form id="menuForm" (ngSubmit)="save()" class="menu-card" #menuForm="ngForm">
    <div class="form-section">
      <h3>Identificação</h3>
      <div class="row g-3">
        <div class="col-md-6">
          <label for="title" class="form-label">Título</label>
          <input type="text" class="form-control" id="title" [(ngModel)]="menu.title" name="title" required
                 (ngModelChange)="onTitleChange($event)" #titleField="ngModel"
                 [class.is-invalid]="titleField.touched && titleField.invalid">
          <div class="invalid-feedback">Título é obrigatório.</div>
        </div>

        <div class="col-md-6">
          <label for="slug" class="form-label">Slug</label>
          <input type="text" class="form-control" id="slug" [(ngModel)]="menu.slug" name="slug" required
                 #slugField="ngModel"
                 (ngModelChange)="slugManuallyEdited = true"
                 [class.is-invalid]="slugField.touched && slugField.invalid">
          <div class="invalid-feedback">Slug é obrigatório.</div>
        </div>

        <div class="col-md-3">
          <label for="posicao" class="form-label">Posição</label>
          <input type="number" class="form-control" id="posicao" [(ngModel)]="menu.posicao" name="posicao" required>
        </div>

        <div class="col-md-5">
          <label for="parentId" class="form-label">Menu Pai</label>
          <select class="form-control" id="parentId" [(ngModel)]="menu.parentId" name="parentId">
            <option [ngValue]="null">Nenhum (menu raiz)</option>
            <option *ngFor="let m of menus" [ngValue]="m.id">{{ m.title }}</option>
          </select>
        </div>

      </div>
    </div>

    <div class="form-section">
      <h3>Metadados</h3>

      <div *ngFor="let entry of metadataEntries; let i = index" class="row g-2 mb-2 align-items-center">
        <div class="col-md-5">
          <input type="text" class="form-control" placeholder="Chave" [(ngModel)]="entry.key" [name]="'meta-key-' + i">
        </div>
        <div class="col-md-5">
          <input type="text" class="form-control" placeholder="Valor" [(ngModel)]="entry.value" [name]="'meta-val-' + i">
        </div>
        <div class="col-md-2">
          <button type="button" class="btn btn-outline-danger btn-sm w-100" (click)="removeMetadataEntry(i)">
            <i class="bi bi-trash"></i> Remover
          </button>
        </div>
      </div>

      <button type="button" class="btn btn-outline-secondary btn-sm mt-1" (click)="addMetadataEntry()">
        + Adicionar metadado
      </button>
    </div>
  </form>

  <footer class="action-bar">
    <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancelar</button>
    <button type="submit" form="menuForm" class="btn btn-primary" [disabled]="isLoading || menuForm.invalid">
      {{ isLoading ? 'Carregando...' : (isEditMode ? 'Salvar Alterações' : 'Cadastrar Menu') }}
    </button>
  </footer>
</section>
